export const ENV_LOCAL = 'LOCAL';
export const ENV_DEV = 'DEV';
export const ENV_INT = 'INT';
export const ENV_STAGE = 'STAGE';
export const ENV_UAT = 'UAT';
export const ENV_PROD = 'PROD';
export const GUEST_SUFFIX = 'guest-plan-selection/browse';

// Portal Sources that require TPA domain
export const PORTAL_SOURCE_GEHA = 'GEHA';
export const PORTAL_SOURCE_UMR = 'UMR';

// Aligned with GUESTURL in playwright/src/utils/constants.psx.ts
export const BASE_URLS: { [key: string]: string } = {
  [ENV_LOCAL]: 'http://localhost:3000/guest',
  [ENV_DEV]: 'https://findcare-dev.guest.uhc.com',
  [ENV_INT]: 'https://findcare-int.guest.uhc.com',
  [ENV_STAGE]: 'https://findcare-stage.guest.uhc.com',
  [ENV_UAT]: 'https://findcare-uat.guest.uhc.com',
  [ENV_PROD]: 'https://findcare.guest.uhc.com',
};

/**
 * Allowed environments for accessing the PSX Deeplink Generator.
 * Only lower environments (LOCAL, DEV, INT) can access the form.
 * Higher environments (STAGE, UAT, PROD) will be redirected.
 */
export const ALLOWED_ENVIRONMENTS = [ENV_LOCAL, ENV_DEV, ENV_INT];

// PAGE HEADINGS & TITLES
export const HEADING_GUEST_DEEPLINK_GENERATOR = 'Guest Deeplink Generator';
export const TITLE_DEEPLINK_FORM = 'Deeplink Form';
export const TITLE_HOW_TO_USE = 'How to Use';
export const TITLE_DEEPLINKS = 'Deeplinks';
export const TITLE_FIELD_REQUIREMENTS = 'Field Requirements';
export const TITLE_DEEPLINK_PROPERTIES = 'Deeplink Properties';
export const TITLE_EXAMPLE_URLS = 'Example URLs';
export const TITLE_ENVIRONMENT_URLS = 'Environment URLs';
export const HEADING_GENERATED_DEEPLINK_URLS = 'Generated Deeplink URLs';

// BANNER MESSAGES
export const BANNER_HOW_TO_USE_MESSAGE =
  'Refer to the below Instructions table with the following required, conditional and optional query parameters';
export const BANNER_DEEPLINK_FORM_MESSAGE =
  'Use the form for easy link generation to generate deeplinks for Guest. Fill in the required fields and any conditional or optional fields as needed. The form will generate encoded deeplink URLs for all environments (Dev, INT, Stage, UAT, Prod).';
export const BANNER_DEEPLINKS_MESSAGE =
  'Below is an example of a Guest deeplink generated for the Choice Plus plan with the specified properties across all environments.';

// BUTTON LABELS
export const BTN_GENERATE = 'Generate';
export const BTN_RESET = 'Reset';
export const BTN_OPEN = 'Open';
export const BTN_COPY = 'Copy';
export const BTN_COPIED = 'Copied!';

// FORM FIELD LABELS
export const LABEL_LANGUAGE = 'Language';
export const LABEL_LOB = 'LOB';
export const LABEL_COVERAGE_TYPE = 'Coverage Type';
export const LABEL_RECIPROCITY_ID =
  'Reciprocity ID/Network ID/Plan ID or H/PBP Code';
export const LABEL_CLIENT_NAME = 'Client Name';
export const LABEL_PLAN_NAME = 'Plan Name';
export const LABEL_PLAN_ID = 'Plan ID or H/PBP Code';
export const LABEL_CUSTOM_BRANDING = 'Custom Branding';
export const LABEL_POLICY_NUMBER = 'Policy Number';
export const LABEL_FIPS_CODE = 'FIPS Code';
export const LABEL_CLUSTER_KEY = 'Cluster Key';
export const LABEL_PORTAL_SOURCE = 'Portal Source';
export const LABEL_PV_RC = 'PV/RC';
export const LABEL_SAVE_WITHOUT_VALIDATION = 'Save without plan validation';
export const LABEL_SHOW_SIGN_IN = 'Show Sign-in';
export const LABEL_PLAN_YEAR = 'Plan Year';
export const LABEL_STATE_CODE = 'State Code';

// TABLE COLUMN HEADERS
export const COLUMN_PROPERTY = 'Property';
export const COLUMN_VALUE = 'Value';
export const COLUMN_REQUIRED = 'Required';
export const COLUMN_REQUIRED_IF = 'Required If';
export const COLUMN_VALUES_EXAMPLES = 'Values/Examples';
export const COLUMN_DESCRIPTION = 'Description';
export const COLUMN_ENVIRONMENT = 'Environment';
export const COLUMN_URL = 'URL';

// FIELD REQUIREMENT STATUSES
export const STATUS_REQUIRED = 'Required';
export const STATUS_CONDITIONAL = 'Conditional';
export const STATUS_OPTIONAL = 'Optional';

// LEGEND
export const LEGEND_TITLE = 'Legend:';
export const LEGEND_REQUIRED_DESC = 'Field must always be filled';
export const LEGEND_CONDITIONAL_DESC =
  'Field is required only under certain conditions';
export const LEGEND_OPTIONAL_DESC = 'Field can be left blank';

// VALIDATION MESSAGES
export const ERROR_LANGUAGE_REQUIRED = 'Language is required';
export const ERROR_LOB_REQUIRED =
  'LOB is required when Reciprocity ID/Network ID/Plan ID or H/PBP Code, Client Name, Plan Name, Policy Number, FIPS Code, Cluster Key, or PV/RC are populated';
export const ERROR_COVERAGE_TYPE_REQUIRED =
  'Coverage Type is required when Plan Name is populated';
export const ERROR_RECIPROCITY_ID_REQUIRED =
  'Reciprocity ID/Network ID/Plan ID or H/PBP Code is required when Plan Name is populated';
export const ERROR_CLIENT_NAME_REQUIRED =
  'Client Name is required when Custom Branding is set to Yes';
export const ERROR_PLAN_NAME_REQUIRED =
  'Plan Name is required when Reciprocity ID/Network ID/Plan ID or H/PBP Code is populated';
export const ERROR_VALIDATION_SUMMARY =
  'Please fix the validation errors above to generate deeplinks';

// COLORS
export const ERROR_COLOR = '#d32f2f';

// FORM PLACEHOLDERS

export const PLACEHOLDER_SELECT_LOB = 'Select LOB';
export const PLACEHOLDER_SELECT_COVERAGE_TYPE = 'Select Coverage Type';
export const PLACEHOLDER_SELECT_LANGUAGE = 'Select Language';
export const PLACEHOLDER_SELECT = 'Select';
export const PLACEHOLDER_RECIPROCITY_ID =
  'e.g., 998, OHMME, B0000551, H0169-012-001';
export const PLACEHOLDER_CLIENT_NAME = 'e.g., GEHA';
export const PLACEHOLDER_PLAN_NAME =
  'e.g., UHC Dual Complete CO-S002 (HMO-POS-D-SNP)';
export const PLACEHOLDER_PLAN_ID = 'e.g., B0000551 or H0169-012-001';
export const PLACEHOLDER_POLICY_NUMBER = 'e.g., 168504';
export const PLACEHOLDER_FIPS_CODE = 'e.g., 12';
export const PLACEHOLDER_CLUSTER_KEY = 'e.g., RP0005UH1';
export const PLACEHOLDER_PORTAL_SOURCE = 'e.g., UMR';
export const PLACEHOLDER_PV_RC = 'e.g., 0001/0001';
export const PLACEHOLDER_PLAN_YEAR = 'e.g., 2026';
export const PLACEHOLDER_STATE_CODE = 'e.g., AZ, IL, CO, TX';

// DROPDOWN OPTIONS
export const OPTION_YES = 'Yes';
export const OPTION_NO = 'No';

// FORM VALUES for yes/no options
export const VALUE_YES = 'yes';
export const VALUE_NO = 'no';

// Language options
export const OPTION_ENGLISH = 'English';
export const OPTION_SPANISH = 'Spanish';
export const OPTION_KOREAN = 'Korean';
export const OPTION_VIETNAMESE = 'Vietnamese';
export const OPTION_TRADITIONAL_CHINESE = 'Traditional Chinese';
export const OPTION_ILOCANO = 'Ilocano';
export const OPTION_BURMESE = 'Burmese';
export const OPTION_HAITIAN_CREOLE = 'Haitian-Creole';

// LOB options
export const OPTION_LOB_EI = 'E&I';
export const OPTION_LOB_MR = 'M&R';
export const OPTION_LOB_CS = 'C&S';
export const OPTION_LOB_IFP = 'IFP';
export const OPTION_LOB_SHOP = 'SHOP';

// Coverage Type options
export const OPTION_COVERAGE_MEDICAL = 'Medical';
export const OPTION_COVERAGE_BEHAVIORAL = 'Behavioral Health';
export const OPTION_COVERAGE_DENTAL = 'Dental';
export const OPTION_COVERAGE_VISION = 'Vision';
export const OPTION_COVERAGE_PHARMACY = 'Pharmacy';

// INSTRUCTIONS TABLE - REQUIRED IF CONDITIONS
export const REQUIRED_IF_ALWAYS = 'Always required';
export const REQUIRED_IF_LOB =
  'Reciprocity ID/Network ID/Plan ID or H/PBP Code or Client Name or Plan Name or Policy Number or FIPS Code or Cluster Key or PV/RC are populated';
export const REQUIRED_IF_COVERAGE_TYPE = 'Plan Name field is populated';
export const REQUIRED_IF_RECIPROCITY_ID = 'Plan Name field is populated';
export const REQUIRED_IF_CLIENT_NAME = 'Custom Branding = Yes';
export const REQUIRED_IF_PLAN_NAME =
  'Reciprocity ID/Network ID/Plan ID or H/PBP Code is populated';
export const REQUIRED_IF_NONE = '-';

// INSTRUCTIONS TABLE - DESCRIPTIONS
export const DESC_LANGUAGE = 'Language to translate PSX content';
export const DESC_LOB = 'Line of Business';
export const DESC_COVERAGE_TYPE = 'Type of coverage or benefit';
export const DESC_RECIPROCITY_ID =
  'Reciprocity ID, Network ID, Plan ID, or H/PBP Code associated with a specific plan';
export const DESC_CLIENT_NAME =
  'Must include a valid client name if custom branding is supported in PSX';
export const DESC_PLAN_NAME = 'PSX Display name in PSX';
export const DESC_PLAN_ID = 'Unique identifier associated with a specific plan';
export const DESC_CUSTOM_BRANDING =
  'Must select Yes if PSX supports custom branded PSX color theme or custom iconography';
export const DESC_POLICY_NUMBER = 'Policy Number';
export const DESC_FIPS_CODE =
  'State FIPS codes primarily for the C&S Medicaid line of business';
export const DESC_CLUSTER_KEY = 'RPK+ProdCode';
export const DESC_PORTAL_SOURCE = 'If blank, portalSource=PSX';
export const DESC_PV_RC = 'Plan variation and reporting code';
export const DESC_SAVE_WITHOUT_VALIDATION =
  "Only use if creating a deeplink for a plan that doesn't exist yet";
export const DESC_SHOW_SIGN_IN =
  'Show or hide all user prompts to sign in with HSID';
export const DESC_PLAN_YEAR = 'If blank, default to current plan year';
export const DESC_STATE_CODE = 'Two-letter state abbreviation';

// INSTRUCTIONS TABLE - VALUES/EXAMPLES
export const VALUES_LANGUAGE =
  'English, Spanish, Korean, Vietnamese, Traditional Chinese, Ilocano, Burmese, Haitian-Creole';
export const VALUES_LOB = 'E&I, M&R, C&S, IFP, SHOP';
export const VALUES_COVERAGE_TYPE =
  'Medical, Behavioral Health, Dental, Vision, Pharmacy';
export const VALUES_RECIPROCITY_ID =
  'example: 998, OHMME, B0000551, H0169-012-001';
export const VALUES_CLIENT_NAME = 'example: GEHA';
export const VALUES_PLAN_NAME =
  'example: UHC Dual Complete CO-S002 (HMO-POS-D-SNP)';
export const VALUES_PLAN_ID = 'example: B0000551 or H0169-012-001';
export const VALUES_CUSTOM_BRANDING = 'Yes, No';
export const VALUES_POLICY_NUMBER = 'example: 168504';
export const VALUES_FIPS_CODE = 'example: 12';
export const VALUES_CLUSTER_KEY = 'example: RP0005UH1';
export const VALUES_PORTAL_SOURCE = 'example: UMR';
export const VALUES_PV_RC = 'example: 0001/0001';
export const VALUES_SAVE_WITHOUT_VALIDATION = 'Selected, Not selected';
export const VALUES_SHOW_SIGN_IN = 'Yes, No';
export const VALUES_PLAN_YEAR = 'example: 2026';
export const VALUES_STATE_CODE = 'example: AZ, IL, CO, TX';

// INSTRUCTIONS TABLE - INPUT TYPES
export const INPUT_TYPE_DROPDOWN = 'Dropdown menu';
export const INPUT_TYPE_FREE_TEXT = 'Free text';
export const INPUT_TYPE_RADIO = 'Radio button';

// SAMPLE DEEPLINK VALUES
export const SAMPLE_PLAN_NAME = 'Choice Plus';
export const SAMPLE_COVERAGE_TYPE = 'medical';
export const SAMPLE_RECIPROCITY_ID = '52';
export const SAMPLE_LOB = 'E&I';
export const SAMPLE_POLICY_NUMBER = '168504';
export const SAMPLE_LANGUAGE = 'en';
